import { useNotification } from "@refinedev/core";

/**
 * Единый хук для показа уведомлений в приложении.
 * Использует Refine useNotification для отображения уведомлений справа сверху.
 *
 * @example
 * const notify = useNotify();
 * notify.success("Операция выполнена успешно");
 * notify.error("Произошла ошибка");
 * notify.info("Информация", "Дополнительное описание");
 * notify.warning("Внимание!");
 */
export const useNotify = () => {
  const { open } = useNotification();

  return {
    success: (message: string, description?: string) => {
      open?.({
        type: "success",
        message,
        description,
      });
    },

    error: (message: string, description?: string) => {
      open?.({
        type: "error",
        message,
        description,
      });
    },

    info: (message: string, description?: string) => {
      open?.({
        type: "success" as any,
        message,
        description,
      });
    },

    warning: (message: string, description?: string) => {
      open?.({
        type: "error" as any,
        message,
        description,
      });
    },

    /**
     * Показывает уведомление с типом "progress" или "info" для длительных операций
     */
    loading: (message: string, description?: string) => {
      open?.({
        type: "progress",
        message,
        description,
      });
    },
  };
};
